import React from 'react';
import {
  change,
  formValueSelector,
  reduxForm,
  getFormValues,
  untouch,
} from 'redux-form';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { i18n } from '@international/mastodon-i18n';
import 'scss/MatrixVerificationForm.scss';
import { getFieldKey } from 'utils';
import MatrixAddressContainer from 'components/Verification/MatrixAddressContainer';
import MatrixSsnContainer from 'components/Verification/MatrixSsnContainer';
import MatrixTextFieldContainer from 'components/Verification/MatrixTextFieldContainer';
import MatrixDateFieldContainer from 'components/Verification/MatrixDateFieldContainer';
import MatrixConsentContainer from 'components/Verification/MatrixConsentContainer';
import { VERIFICATION_FORM_NAME } from '../../../constants';
import MvrMatrixDocumentUploadContainer from './MvrMatrixDocumentUploadContainer';

const DOCUMENT_TYPES = ['document', 'document_download_upload'];

function MvrMatrixVerificationForm({
  company,
  fields,
  formValues,
  array,
  changeField,
  untouchField,
  noSsn,
}) {
  const setField = (name, value) => {
    changeField(VERIFICATION_FORM_NAME, name, value);
  };

  const addressField = fields.find(f => f.type === 'address');
  const ssnField = fields.find(f => f.type === 'ssn');
  const textField = fields.find(f => f.type === 'short_text');
  const dateField = fields.find(f => f.type === 'date');
  const eSignedConsentField = fields.find(f => f.type === 'consent_collection');
  const documentFields = fields.filter(f => DOCUMENT_TYPES.includes(f.type));

  return (
    <>
      <MatrixAddressContainer field={addressField} setField={setField} />
      <MatrixSsnContainer
        field={ssnField}
        noSsn={noSsn}
        setField={setField}
        untouchField={untouchField}
      />
      <MatrixTextFieldContainer field={textField} />
      <MatrixDateFieldContainer field={dateField} />
      {documentFields.map(field => {
        const key = getFieldKey(field);
        return (
          <MvrMatrixDocumentUploadContainer
            key={key}
            field={field}
            formValue={formValues[key] || {}}
            onRemoveFile={index => array.remove(`${key}.${field.type}`, index)}
          />
        );
      })}
      <MatrixConsentContainer field={eSignedConsentField} company={company} />
    </>
  );
}

MvrMatrixVerificationForm.propTypes = {
  company: PropTypes.string,
  fields: PropTypes.array.isRequired,
  formValues: PropTypes.any.isRequired,
  array: PropTypes.any.isRequired,
  changeField: PropTypes.func.isRequired,
  untouchField: PropTypes.func.isRequired,
  noSsn: PropTypes.bool,
};

MvrMatrixVerificationForm.defaultProps = {
  company: '',
  noSsn: false,
};

const MvrMatrixVerificationReduxForm = reduxForm({
  form: VERIFICATION_FORM_NAME,
})(MvrMatrixVerificationForm);

const selector = formValueSelector(VERIFICATION_FORM_NAME);
const mapStateToProps = state => {
  const values = getFormValues(VERIFICATION_FORM_NAME)(state) || {};
  let submissionId = '';

  Object.entries(values).forEach(([key, value]) => {
    if (value && typeof value === 'object' && value.noSsn) {
      submissionId = key;
    }
  });

  return {
    formValues: values,
    noSsn: selector(state, `${submissionId}.noSsn`) || false,
  };
};

const mapDispatchToProps = {
  changeField: change,
  untouchField: untouch,
};

export default i18n.renderTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(MvrMatrixVerificationReduxForm),
);
